var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', {
    staticClass: "gh-linkList"
  }, [_c('li', [_c('menu-link', {
    attrs: {
      "href": "https://www.cambridge.org/core"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._v("Cambridge Core")];
      },
      proxy: true
    }])
  }, [_vm._v(" The home of academic research. ")])], 1), _c('li', [_c('menu-link', {
    attrs: {
      "href": "https://www.cambridge.org/highereducation"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._v("Cambridge Aspire")];
      },
      proxy: true
    }])
  }, [_vm._v(" Textbooks and courseware to enhance online learning. ")])], 1), _c('li', [_c('menu-link', {
    attrs: {
      "href": "https://www.cambridge.org/engage"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._v("Cambridge Open Engage")];
      },
      proxy: true
    }])
  }, [_vm._v(" The venue for researchers to collaborate, upload, and share their early research. ")])], 1), _c('li', [_c('menu-link', {
    attrs: {
      "href": "https://www.cambridge.org/authorhub"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._v("Author Hub")];
      },
      proxy: true
    }])
  }, [_vm._v(" Practical advice and support for new and existing authors. ")])], 1), _c('li', [_c('menu-link', {
    attrs: {
      "href": "https://advanceonline.cam.ac.uk",
      "new-window": true
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._v("Cambridge Advance Online "), _c('span', {
          staticClass: "srOnly"
        }, [_vm._v("(Opens in a new window)")]), _c('div', {
          staticClass: "gh-external"
        }, [_c('div', [_c('icon-external', {
          staticClass: "gh-icon"
        })], 1)])];
      },
      proxy: true
    }])
  }, [_vm._v(" Short online courses for professionals, delivered by University of Cambridge academics. ")])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };